 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		68: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"0":"bundles/pages/indexOld.js","1":"bundles/pages/index.js","2":"bundles/pages/single-fund.js","3":"bundles/pages/single-fund-new.js","4":"bundles/pages/grow-wealth.js","5":"bundles/pages/dashboard.js","6":"bundles/pages/plan.js","7":"bundles/pages/search.js","8":"bundles/pages/compare-funds.js","9":"bundles/pages/kyc.js","10":"bundles/pages/sip-calculator.js","11":"bundles/pages/mfHome.js","12":"bundles/pages/nfos.js","13":"bundles/pages/plan-v2.js","14":"bundles/pages/save-taxes.js","15":"bundles/pages/amc.js","16":"bundles/pages/profile.js","17":"bundles/pages/amcNew.js","18":"bundles/pages/currency.js","19":"bundles/pages/elss-calculator.js","20":"bundles/pages/personalized-plan.js","21":"bundles/pages/personalised-plan.js","22":"bundles/pages/f2s.js","23":"bundles/pages/invest.js","24":"bundles/pages/google-auth.js","25":"bundles/pages/postFiling.js","26":"bundles/pages/whatsapp-confirmation.js","27":"bundles/pages/nfoDetails.js","28":"bundles/pages/mandate.js","29":"bundles/pages/_error.js","30":"bundles/pages/filing-to-save.js","31":"bundles/pages/currency/components/banner/Banner.js","32":"bundles/pages/currency/components/Conversionfold/Graph/Graph.js","33":"bundles/pages/complete-kyc.js","34":"bundles/pages/rent-page.js","35":"bundles/pages/amcs.js","36":"bundles/pages/currency/components/FAQ/Faq.js","37":"bundles/pages/special-referral.js","38":"bundles/pages/login.js","39":"bundles/pages/currency/components/Conversionfold/Graph/graphConstant.js","40":"bundles/pages/currency/components/Conversionfold/Converter/converter.js","41":"bundles/pages/currency/components/Aboutcurrenies/Aboutcurrenies.js","42":"bundles/pages/currency/components/Popularconversions/Popularconversions.js","43":"bundles/pages/calculator80C.js","44":"bundles/pages/status.js","45":"bundles/pages/redirect.js","46":"bundles/pages/yesBankCrisisFaq.js","47":"bundles/pages/referral.js","48":"bundles/pages/refer.js","49":"bundles/pages/redeemSummary.js","50":"bundles/pages/paymentSuccess.js","51":"bundles/pages/payment.js","52":"bundles/pages/mandate-status.js","53":"bundles/pages/logout.js","54":"bundles/pages/indexMobile.js","55":"bundles/pages/help.js","56":"bundles/pages/demo.js","57":"bundles/pages/dashboardRedirect.js","58":"bundles/pages/currency/currencyConst.js","59":"bundles/pages/currency/components/FAQ/faqdropdown/faqdropdown.js","60":"bundles/pages/currency/components/Conversionfold/Converter/ConverterInput/ConverterInput.js","61":"bundles/pages/currency/components/Commondenominations/Commondenominations.js","62":"bundles/pages/currency/components/Aboutcurrenies/CurrencyInformation/CurrencyInformation.js","63":"bundles/pages/currency/api.js","64":"bundles/pages/complete-payment.js","65":"bundles/pages/appIssues.js","66":"bundles/pages/currency/util/recaptcha.js","67":"bundles/pages/currency/components/Navbar/Productmenu/ProductsMenu.js"}[chunkId]||chunkId) + "-" + {"0":"c834d3db1727e497b0e5","1":"d07d53274b8c7fc3f596","2":"b8dd893e3b98698ea217","3":"b9a8f0143b06b5f412b0","4":"aab9b4b22020db7edbb5","5":"05984b6781b738a5f92a","6":"ea9d99603999a1ebf53e","7":"5411a650b95bc46b99a8","8":"ea5795b0be29f033606f","9":"28237dd7b7e1e7879e76","10":"4195e0416f817b1f8e0f","11":"380881092f8d5ff17b4b","12":"72c426767277571192f4","13":"e85c2fc35ed72c643001","14":"367291655a73146ef611","15":"3051740f16a871945d0b","16":"e9d4ed031720162c8c33","17":"beea73d1a924fb70abf2","18":"28b22cd12110090397df","19":"dda323fb4d6f3d9f3491","20":"8736d06f0df8d5693284","21":"a92a863e3e824faa1545","22":"1f0fa704e87eeb41302c","23":"330694fdea0773fd3a13","24":"a73578fce3495c98176e","25":"5fbe9459b8ae8d557265","26":"a1d2d439266d4eadfcae","27":"5fbeb52b392c7e402798","28":"4d930d430988fb5edc2f","29":"fd2a652dca1492037a43","30":"8e25525262c25ed6d72c","31":"10afc9ed70acc7ae886d","32":"1b58e86b4bf3e1f5f8c7","33":"644538b29a5beee86a49","34":"396d00e99fa9152e9a96","35":"6d85e4ca76f8d7baaf5a","36":"a3ebac8f8e65e8cb3a0f","37":"c2f80c5ab2cc3dd02127","38":"90c544faa18456ba13d4","39":"fb4d995cc397f0d98625","40":"c85dcdce573f82b8d72e","41":"dff8940e3637d8a13d64","42":"a156d6adf9328d195f57","43":"7980ac4bf93b0fc8ead7","44":"10a4f452ec2aaab9d063","45":"d048d7496c1f6e870e0d","46":"11029aa34e5c7a0c7843","47":"fec26910d1f36ffcbbc3","48":"e0d4e3f320309037e151","49":"c8691b83d27b1fe11ed6","50":"2a6d84b20783a3ce33b2","51":"ab1483fa59a6d418920e","52":"d0f059ad518c33c6074b","53":"cb8379952b0d83bc4df7","54":"b84828d745f508cb2daa","55":"2a7dea6dd0421b675ff3","56":"82c6eb9371dd0b6fd6ec","57":"8b0709377f63ab8909dc","58":"969707867db71c46e773","59":"81190322e3b6544898e6","60":"eae78b3103af64cf1f63","61":"8a969a0e45b2bc09f2ea","62":"42950c635f1d1dabf253","63":"8bd8338c02ef2027668a","64":"80f2d7a322a38c9ce832","65":"817d4d33528c9ea15223","66":"568b8c0d00f6ee78992c","67":"b9d34068c0594b82b6de"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 752);



// WEBPACK FOOTER //
// webpack/bootstrap 37d28ae32cff6a19b2e3